import React, { useState } from 'react'
import {
    Box,
    TextField,
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core'
import {
    Delete as DeleteIcon,
    GetApp as DownloadIcon,
    MoreVert,
} from '@material-ui/icons'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'

interface RentRollTableHeaderProps {
    search: string
    onSearchChange: (value: string) => void
    onDownload?: () => void
    onDelete: () => void
    isDownloadDisabled?: boolean
    isDownloading?: boolean
    isDeleteDisabled?: boolean
    classes: ClassNameMap<string>
}

export const RentRollTableHeader: React.FC<RentRollTableHeaderProps> = ({
    search,
    onSearchChange,
    onDownload,
    onDelete,
    isDownloadDisabled = false,
    isDownloading = false,
    classes,
}) => {
    const [actionsAnchorEl, setActionsAnchorEl] = useState<null | HTMLElement>(
        null,
    )
    const handleActionsOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setActionsAnchorEl(event.currentTarget)
    }
    const handleActionsClose = () => {
        setActionsAnchorEl(null)
    }
    const actionMenuSecondaryTypographyProps = {
        style: {
            whiteSpace: 'normal' as const,
            maxWidth: 260,
        },
    }

    return (
        <Box className={classes.toolbar}>
            <Box className={classes.toolbarLeft}>
                <TextField
                    placeholder="Search by resident..."
                    variant="outlined"
                    size="small"
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                    style={{ minWidth: 250 }}
                />
            </Box>
            <Box className={classes.toolbarRight}>
                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<MoreVert />}
                    onClick={handleActionsOpen}
                    className={classes.actionButton}
                >
                    Actions
                </Button>
                <Menu
                    anchorEl={actionsAnchorEl}
                    open={Boolean(actionsAnchorEl)}
                    onClose={handleActionsClose}
                >
                    {onDownload && (
                        <MenuItem
                            onClick={() => {
                                onDownload()
                                handleActionsClose()
                            }}
                            disabled={isDownloadDisabled || isDownloading}
                        >
                            <ListItemIcon>
                                <DownloadIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    isDownloading
                                        ? 'Downloading...'
                                        : 'Download Rent Roll'
                                }
                                secondary="Download the original rent roll file uploaded for this audit."
                                secondaryTypographyProps={
                                    actionMenuSecondaryTypographyProps
                                }
                            />
                        </MenuItem>
                    )}
                    <MenuItem
                        onClick={() => {
                            onDelete()
                            handleActionsClose()
                        }}
                    >
                        <ListItemIcon>
                            <DeleteIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Delete Rent Roll"
                            secondary="Delete the rent roll for this audit. This will give you the opportunity to upload a new rent roll."
                            secondaryTypographyProps={
                                actionMenuSecondaryTypographyProps
                            }
                        />
                    </MenuItem>
                </Menu>
            </Box>
        </Box>
    )
}
